import React from "react";
import {
  Grid,
  MenuItem,
  InputAdornment,
  Tooltip,
  IconButton,
  Typography,
} from "@mui/material";
import { Info } from "@mui/icons-material";

import {
  Autocomplete,
  ComponentHeader,
  Label,
  Paper,
  TextField,
} from "../../../components";

export default function FormDisplay({
  formikProps,
  language,
  category,
  addSample,
  botDetails,
}) {
  const handleChangeLanguage = (value, type) => {
    if (type === "selectOption") {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        templateLanguage: setTemplateLanguage(prevVal.templateLanguage),
      }));

      function setTemplateLanguage(templateLanguage) {
        templateLanguage.code_id = value._id;
        return templateLanguage;
      }
    } else {
      value = {
        _id: "",
        language: "",
      };
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        templateLanguage: setTemplateLanguage(prevVal.templateLanguage),
      }));
      function setTemplateLanguage(templateLanguage) {
        templateLanguage.code_id = value._id;
        return templateLanguage;
      }
    }
  };

  return (
    <React.Fragment>
      <Paper className="topElement">
        <Grid item xs={12}>
          <ComponentHeader title="Template Details" />
          <Typography
            variant="subtitle2"
            gutterBottom
            style={{ color: "#808080b3" }}
          >
            WhatsApp message templates are specific message formats that
            businesses use to send out notifications or customer care messages
            to people.
          </Typography>
        </Grid>

        <Grid style={{ paddingTop: "0px" }} item xs={12}>
          {botDetails?.authentication?.whatsapp_server === "normal" && (
            <Typography style={{ fontSize: "13px", color: "#0c5460" }}>
              <Typography variant="button" style={{ color: "#ff0000" }}>
                Important:
              </Typography>{" "}
              Please register only the{" "}
              <Typography variant="button" color="primary">
                Approved Templates
              </Typography>{" "}
              here or else they'll be not of use.
            </Typography>
          )}
        </Grid>

        <Grid item xs={6}>
          <Label
            title="Template Name"
            required={true}
            formikProps={formikProps}
            name="templateName"
          />

          <TextField
            name="templateName"
            required
            placeholder="Template Name"
            disabled={
              Boolean(formikProps.values.ID) ||
              Boolean(addSample) ||
              formikProps.isSubmitting
            }
            formikProps={formikProps}
            inputProps={{
              maxLength: 512,
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {formikProps.values?.templateName.length}/512
                  <IconButton>
                    <Tooltip title="When creating a message template, it is mandatory to give it a name. It is advised that the name reflect the template’s content. This name must only contain lowercase letters, numbers, and underscores.">
                      <Info />
                    </Tooltip>
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Label
            title="Template Language"
            required={true}
            formikProps={formikProps}
            name="templateLanguage.code_id"
          />

          <Autocomplete
            placeholder="Template Language"
            name="templateLanguage.code_id"
            defaults={{
              primaryKey: "_id",
              displayLabel: "language",
            }}
            options={language}
            disabled={
              Boolean(formikProps.values.ID) ||
              Boolean(addSample) ||
              formikProps.isSubmitting
            }
            onChange={(_, value, type) => handleChangeLanguage(value, type)}
            formikProps={formikProps}
          />
        </Grid>

        <Grid item xs={6}>
          <Label
            title="Template Status"
            required={true}
            formikProps={formikProps}
            name="status"
          />

          <TextField
            select
            required
            placeholder="Template Status"
            name="status"
            disabled={
              Boolean(formikProps.values.ID) ||
              Boolean(addSample) ||
              formikProps.isSubmitting
            }
            formikProps={formikProps}
          >
            <MenuItem value={true}>Active</MenuItem>
            <MenuItem value={false}>Inactive</MenuItem>
          </TextField>
        </Grid>

        <Grid item xs={6}>
          <Label
            title="Template Category"
            required={true}
            formikProps={formikProps}
            name="category"
          />

          <TextField
            select
            required
            name="category"
            disabled={
              Boolean(formikProps.values.ID) ||
              Boolean(addSample) ||
              formikProps.isSubmitting
            }
            formikProps={formikProps}
            value={formikProps.values.category || ""}
            SelectProps={{
              displayEmpty: true, // important to show the first empty value
            }}
            sx={{
              "& .MuiSelect-select": {
                color: formikProps.values.category ? "inherit" : "#a2a2a2", // placeholder color
              },
            }}
          >
            <MenuItem value="" disabled>
              Select Template category
            </MenuItem>
            {category.map((item) => (
              <MenuItem
                key={item._id}
                value={item._id}
                sx={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  maxWidth: 400,
                }}
              >
                <div>
                  <Typography variant="subtitle1">
                    {item.display_name}
                  </Typography>
                  <Typography>{item.description}</Typography>
                </div>
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Paper>
    </React.Fragment>
  );
}
